import BaseEntity from '@/entities/BaseEntity';

export default class SiteLink extends BaseEntity {
  _uid = null;
  site_link_title = '';
  site_link_url = '';
  image_file_id = null;
  image_url = null;

  _uploading = false;

  constructor(rawData) {
    super();
    this._uid = this.generateUid();
    this.updateWith(rawData);
  }

  get isComplete() {
    return !!this.site_link_title
      && !!this.site_link_url
      && !!this.image_file_id;
  }

  toObject() {
    const output = super.toObject();

    return output;
  }

  generateUid() {
    return Math.random().toString(36).slice(2);
  }
}
